import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Modal, Form } from "react-bootstrap";
import { ButtonComponent, AnchorComponent } from "../elements";
import axios from "axios";
import Select from "react-select";
import { encode } from "base-64";
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import PaginationComponent from "../../components/PaginationComponent";
import { Row, Col } from "react-bootstrap";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import "./ClinicTable.css";

export default function DeletedDoctorTableComponent({ thead, tbody }) {
  const { t } = useContext(TranslatorContext);
  const [doctorDetails, setDoctorDetails] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedClinic, setselectedClinic] = useState([]);

  const [services, setservices] = useState([]);
  const [clinic, setclinic] = useState([]);

  const [Error, setError] = useState("");
  const [DeleteId, setDeleteId] = useState("");

  const [userData, setUserData] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [AddModal, setAddModal] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [DeleteClinic, setDeleteClinic] = useState("");
  const [editclinicId, seteditClinicId] = useState("");
  const [editclinicName, seteditClinicName] = useState("");
  const [editexperience, seteditexperience] = useState("");
  const [editclinicCity, seteditClinicCity] = useState("");
  const [editimage, seteditimage] = useState("");
  const [editabout, seteditabout] = useState("");
  const [editAvailability, seteditAvailability] = useState("");

  const [editclinicNameerror, seteditClinicNameerror] = useState("");
  const [editserviceError, seteditserviceError] = useState("");
  const [editclinicerror, seteditclinicerror] = useState("");
  const [editabouterror, seteditabouterror] = useState("");
  const [editexperienceError, seteditexperienceError] = useState("");
  const [editAvailabilityError, seteditAvailabilityError] = useState("");

  const [AddDoctorName, setAddDoctorName] = useState("");
  const [AddService, setAddService] = useState([]);
  const [AddClinic, setAddClinic] = useState("");
  const [AddExperience, setAddExperience] = useState("");
  const [AddAvailability, setAddAvailability] = useState("");
  const [addImage, setaddImage] = useState("");
  const [AddAbout, setAddAbout] = useState("");

  const [AddDoctorNameError, setAddDoctorNameError] = useState("");
  const [AddServiceError, setAddServiceError] = useState("");
  const [AddClinicError, setAddClinicError] = useState("");
  const [AddExperienceError, setAddExperienceError] = useState("");
  const [AddAvailabilityError, setAddAvailabilityError] = useState("");
  const [addImageError, setaddImageError] = useState("");
  const [AddAboutError, setAddAboutError] = useState("");

  const [status, setstatus] = useState("");
  const [activeDeactiveDoctor, setactiveDeactiveDoctor] = useState("");

  const [saveEditLoading, setSaveEditLoading] = useState(false);
  const [addDoctorLoading, setAddDoctorLoading] = useState(false);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const entriesPerPage = 5;

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  const filteredUsers = doctorDetails.filter((user) => {
    const lowercasedTerm = searchTerm.toLowerCase();
    return (
      user.doctor_name?.toLowerCase().includes(lowercasedTerm) ||
      user.clinic_name?.toLowerCase().includes(lowercasedTerm) ||
      (user.availability_status === 0 ? "not available" : "available")
        .toLowerCase()
        .includes(lowercasedTerm) ||
      user.createtime?.toLowerCase().includes(lowercasedTerm)
    );
  });

  const currentUsers = filteredUsers.slice(indexOfFirstEntry, indexOfLastEntry);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const fetchClinicDetails = () => {
    const user_type = localStorage.getItem("user_type");

    axios
      .post(API_URL + "/fetch_deleted_doctors", { user_type })
      .then((response) => {
        console.log("deleted doctors", response.data);
        setDoctorDetails(response.data.doctor_arr.reverse() || []);
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  };

  const getServices = () => {
    const user_type = localStorage.getItem("user_type");
    axios
      .post(API_URL + "/fetch_services", { user_type })
      .then((res) => {
        const formattedServices = res.data.service_arr.map((service) => ({
          label: service.service_name,
          value: service.service_id,
        }));
        setservices(formattedServices);
        console.log("servicesssss", formattedServices);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getClinic = () => {
    const user_type = localStorage.getItem("user_type");

    axios
      .post(API_URL + "/get_our_clinics", { user_type })
      .then((res) => {
        const formattedclinic = res.data.clinic_arr.map((service) => ({
          label: service.clinic_name,
          value: service.clinic_id,
        }));
        setclinic(formattedclinic);
        console.log(formattedclinic);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchClinicDetails();
    getServices();
    getClinic();
  }, []);

  const handleUserAction = (action, doctor_id) => {
    if (action === "active") {
      setactiveDeactiveDoctor(doctor_id);
      setstatus("activate");
      setAlertModal(true);
    } else if (action === "deactive") {
      setactiveDeactiveDoctor(doctor_id);
      setstatus("deactivate");

      setAlertModal(true);
    }
  };

  const DoctorActiveDeactive = () => {
    console.log("asdf", activeDeactiveDoctor);

    axios
      .post(API_URL + "/activate_deactivate_doctor", {
        doctor_id: activeDeactiveDoctor,
      })
      .then((res) => {
        if (res.data.success) {
          fetchClinicDetails();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const DoctorDelete = () => {
    axios
      .post(API_URL + "/delete_doctor", { doctor_id: DeleteId })
      .then((res) => {
        if (res.data.success) {
          fetchClinicDetails();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSaveChanges = () => {
    let hasError = false;
    if (!editclinicName || editclinicName.trim() == "") {
      seteditClinicNameerror("Please enter clinic name");
      hasError = true;
    }
    if (!selectedServices || selectedServices.length === 0) {
      seteditserviceError("Please select service");
      hasError = true;
    }
    if (!selectedClinic || selectedClinic.length === 0) {
      seteditclinicerror("Please select clinic");
      hasError = true;
    }
    if (!editexperience || editexperience.trim() == "") {
      seteditexperienceError("Please enter experience & qualification");
      hasError = true;
    }
    if (!editAvailability || editAvailability.trim() == "") {
      seteditAvailabilityError("Please select availability");
      hasError = true;
    }
    if (!editabout || editabout.trim() == "") {
      seteditabouterror("Please enter about clinic");
      hasError = true;
    }

    if (hasError) {
      return;
    }
    var services = JSON.stringify(selectedServices.map((user) => user.value));

    const formData = new FormData();
    formData.append("doctor_id", editclinicId);
    formData.append("doctor_name", editclinicName);
    formData.append("service_id", services);
    formData.append("clinic_id", selectedClinic.value);
    formData.append("experience_qualification", editexperience);
    formData.append("availability_status", editAvailability);
    formData.append("about_doctor", editabout);

    if (editimage) {
      formData.append("image", editimage);
    }

    setSaveEditLoading(true);
    axios
      .post(API_URL + "/edit_doctor", formData)
      .then((response) => {
        setEditModal(false);
        fetchClinicDetails();
      })
      .catch((error) => console.error("Error updating doctor:", error))
      .finally(() => setSaveEditLoading(false));
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // add doctor
  const handleAddDoctor = () => {
    let hasError = false;
    if (!AddDoctorName || AddDoctorName.trim() == "") {
      setAddDoctorNameError("Please enter doctor name");
      hasError = true;
    }
    if (!AddService || AddService.length === 0) {
      setAddServiceError("Please select service");
      hasError = true;
    }
    if (!AddClinic || AddClinic.length === 0) {
      setAddClinicError("Please select clinic ");
      hasError = true;
    }
    if (!AddExperience || AddExperience.trim() == "") {
      setAddExperienceError("Please enter experience & qualificaion");
      hasError = true;
    }
    if (!AddAvailability || AddAvailability.trim() == "") {
      setAddAvailabilityError("Please enter longitude");
      hasError = true;
    }
    if (!AddAbout || AddAbout.trim() == "") {
      setAddAboutError("Please enter about clinic");
      hasError = true;
    }
    if (!addImage) {
      setaddImageError("Please upload image");
      hasError = true;
    }

    if (hasError) {
      return;
    }
    var services = JSON.stringify(AddService.map((user) => user.value));

    // const data = {
    //     clinic_name: AddClinicName,
    //     clinic_city: AddClinicCity,
    //     service_id: services,
    //     latitude: AddLatitude,
    //     longitude: AddLongitude,
    //     about_clinic: AddAbout,
    //     image: AddImage,
    //     AddMultipleImg: AddMultipleImg
    // }

    const formData = new FormData();
    formData.append("doctor_name", AddDoctorName);
    formData.append("service_id", services);
    formData.append("clinic_id", AddClinic.value);
    formData.append("experience_qualification", AddExperience);
    formData.append("availability_status", AddAvailability);
    formData.append("about_doctor", AddAbout);
    formData.append("image", addImage);

    setAddDoctorLoading(true);
    axios
      .post(API_URL + "/add_doctor", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.key === "exist") {
          setError("Doctor Already Exist");
          return;
        }
        if (response.data.success) {
          setAddModal(false);
          fetchClinicDetails();
        }
      })
      .catch((error) => console.error("Error adding doctor:", error))
      .finally(() => setAddDoctorLoading(false));
  };

  return (
    <>
      <Row
        xs={1}
        sm={2}
        xl={4}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Col>
          <LabelFieldComponent
            type="search"
            // label={t('search_by')}
            icon="Search"
            placeholder={`${t("search_here")}`}
            labelDir="label-col"
            fieldSize="mb-4 w-100 h-md"
            value={searchTerm}
            onChange={handleSearch}
          />
        </Col>
        {/* <Col style={{ textAlign: 'right', marginBottom: '5px' }}>
                    <button style={{ background: '#2b77e5', padding: '7px 13px', color: '#fff', borderRadius: '5px' }} onClick={() => setAddModal(true)} > <AddIcon className="me-2" /> {t("add_doctor")} </button>
                </Col> */}
      </Row>

      <div className="mc-table-responsive">
        <table className="mc-table">
          <thead className="mc-table-head primary">
            <tr>
              <th>
                <div className="mc-table-check">
                  <p>{t("sno")}</p>
                </div>
              </th>
              <th>{t("image")}</th>
              <th>{t("doctor_name")}</th>
              <th>{t("clinic_name")}</th>
              <th>{t("status")}</th>
              <th>{t("createtime")}</th>
            </tr>
          </thead>
          <tbody className="mc-table-body even">
            {currentUsers?.map((item, index) => (
              <tr key={index}>
                <td title="id">
                  <div className="mc-table-check">
                    <p>{indexOfFirstEntry + index + 1}</p>
                  </div>
                </td>
                {/* <td>
                                    <div className="mc-table-action">

                                        <AnchorComponent to={`${APP_PREFIX_PATH}/doctor-view/${encode(item.doctor_id)}`} title="View" className="material-icons view">visibility</AnchorComponent>
                                  
                                        {item.active_flag === 0 ? (
                                            <AnchorComponent
                                                title="inactive"
                                                className="material-icons inactive"
                                                style={{ background: '#d4ffd4', color: 'green', lineHeight: '15px' }}
                                                onClick={() => { handleUserAction('active', item.doctor_id) }}
                                            >

                                                <ToggleOnIcon />
                                            </AnchorComponent>
                                        ) : (
                                            <AnchorComponent
                                                title="active"
                                                className="material-icons active"
                                                style={{ background: 'rgb(255 223 223)', color: 'red', lineHeight: '15px' }}
                                                onClick={() => { handleUserAction('deactive', item.doctor_id) }}
                                            >
                                                <ToggleOffIcon />
                                            </AnchorComponent>
                                        )}

                                    </div>
                                </td> */}
                <td title={item.clinic_name}>
                  <div className="mc-table-profile">
                    <img
                      src={
                        item.image
                          ? `${item.image}`
                          : `doctor_placeholder.webp`
                      }
                      alt="Profile"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </td>
                <td>
                  <span>{item.doctor_name || "NA"}</span>
                </td>
                <td>{item.clinic_name || "NA"}</td>
                <td>{item.active_flag == 0 ? "Deactive" : "Active"}</td>
                <td>{item.createtime || "NA"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <PaginationComponent
          totalEntries={filteredUsers.length}
          entriesPerPage={entriesPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />

        <Modal show={editModal} onHide={() => setEditModal(false)}>
          <div className="mc-user-modal">
            <img
              src={
                userData.image
                  ? `${userData.image}`
                  : `placeholder.webp`
              }
              alt="Profile"
            />
            <h4>{userData?.name}</h4>
            <p>{userData?.email}</p>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("doctor_name")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_doctor_name")}
                value={editclinicName}
                onChange={(e) => {
                  seteditClinicName(e.target.value);
                  seteditClinicNameerror("");
                }}
              />
              <p style={{ color: "red" }}>{editclinicNameerror}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_service")}</Form.Label>

              <Select
                isMulti
                options={services}
                value={selectedServices}
                onChange={(e) => {
                  setSelectedServices(e);
                  seteditserviceError("");
                }}
                placeholder={t("enter_service_name")}
              />

              <p style={{ color: "red" }}>{editserviceError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("select_clinic")}</Form.Label>

              <Select
                options={clinic}
                value={selectedClinic}
                onChange={(e) => {
                  setselectedClinic(e);
                  seteditclinicerror("");
                }}
                placeholder={t("enter_service_name")}
              />

              <p style={{ color: "red" }}>{editclinicerror}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("experience_qualification")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_experience_qualification")}
                value={editexperience}
                onChange={(e) => {
                  seteditexperience(e.target.value);
                  seteditexperienceError("");
                }}
              />
              <p style={{ color: "red" }}>{editexperienceError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("availability_status")}</Form.Label>
              <Form.Control
                as="select"
                value={editAvailability}
                onChange={(e) => {
                  seteditAvailability(e.target.value);
                  seteditAvailabilityError("");
                }}
              >
                <option value="">{t("select_availability_status")}</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </Form.Control>
              <p style={{ color: "red" }}>{editAvailabilityError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("image")}</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  seteditimage(file);
                }}
              />
            </Form.Group>
            <Form.Group className="form-group">
              <Form.Label>{t("about_me")}</Form.Label>
              <Form.Control
                as="textarea"
                placeholder={t("enter_about_me")}
                value={editabout}
                onChange={(e) => {
                  seteditabout(e.target.value);
                  seteditabouterror("");
                }}
              />
              <p style={{ color: "red" }}>{editabouterror}</p>
            </Form.Group>
            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setEditModal(false);
                  seteditClinicNameerror("");
                  seteditclinicerror("");
                  seteditserviceError("");
                  seteditexperienceError("");
                  seteditAvailabilityError("");
                  seteditabouterror("");
                  setselectedClinic("");
                  setSelectedServices("");
                }}
              >
                {t("close_popup")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className="btn btn-success"
                onClick={handleSaveChanges}
                disabled={saveEditLoading}
              >
                {saveEditLoading ? t("loading") || "Loading..." : t("save_changes")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal show={AddModal} onHide={() => setAddModal(false)}>
          <div className="mc-user-modal">
            <img
              src={
                userData.image
                  ? `${userData.image}`
                  : `placeholder.webp`
              }
              alt="Profile"
            />
            <h4>{userData?.name}</h4>
            <p>{userData?.email}</p>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("doctor_name")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_doctor_name")}
                value={AddDoctorName}
                onChange={(e) => {
                  setAddDoctorName(e.target.value);
                  setAddDoctorNameError("");
                  setError("");
                }}
              />
              <p style={{ color: "red" }}>{AddDoctorNameError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_service")}</Form.Label>

              <Select
                isMulti
                options={services}
                value={AddService}
                onChange={(e) => {
                  setAddService(e);
                  setAddServiceError("");
                }}
                placeholder={t("enter_service_name")}
              />

              <p style={{ color: "red" }}>{AddServiceError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("select_clinic")}</Form.Label>

              <Select
                options={clinic}
                value={AddClinic}
                onChange={(e) => {
                  setAddClinic(e);
                  setAddClinicError("");
                }}
                placeholder={t("enter_service_name")}
              />

              <p style={{ color: "red" }}>{AddClinicError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("experience_qualification")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_experience_qualification")}
                value={AddExperience}
                onChange={(e) => {
                  setAddExperience(e.target.value);
                  setAddExperienceError("");
                }}
              />
              <p style={{ color: "red" }}>{AddExperienceError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("availability_status")}</Form.Label>
              <Form.Control
                as="select"
                value={AddAvailability}
                onChange={(e) => {
                  setAddAvailability(e.target.value);
                  setAddAvailabilityError("");
                }}
              >
                <option value="">{t("select_availability_status")}</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </Form.Control>
              <p style={{ color: "red" }}>{AddAvailabilityError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("image")}</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setaddImage(file);
                  setaddImageError("");
                }}
              />
              <p style={{ color: "red" }}>{addImageError}</p>
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Label>{t("about_me")}</Form.Label>
              <Form.Control
                as="textarea"
                placeholder={t("enter_about_me")}
                value={AddAbout}
                onChange={(e) => {
                  setAddAbout(e.target.value);
                  setAddAboutError("");
                }}
              />
              <p style={{ color: "red" }}>{AddAboutError}</p>
            </Form.Group>
            <p style={{ color: "red" }}>{Error}</p>
            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setAddModal(false);
                  setAddDoctorNameError("");
                  setAddServiceError("");
                  setAddClinicError("");
                  setAddExperienceError("");
                  setAddAvailabilityError("");
                  setAddAboutError("");
                  setAddClinic("");
                  setAddService("");
                  setAddDoctorName("");
                  setAddExperience("");
                  setAddAvailability("");
                  setAddAbout("");
                  setaddImage("");
                  setError("");
                }}
              >
                {t("close_popup")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className="btn btn-success"
                onClick={handleAddDoctor}
                disabled={addDoctorLoading}
              >
                {addDoctorLoading ? t("loading") || "Loading..." : t("save_changes")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal show={alertModal} onHide={() => setAlertModal(false)}>
          <div className="mc-alert-modal">
            <i className="material-icons">new_releases</i>
            <h3>are your sure!</h3>
            <p>Want to {status} this doctor?</p>
            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => setAlertModal(false)}
              >
                {t("close")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className={`btn ${
                  status === "activate" ? "btn-success" : "btn-danger"
                }`}
                onClick={() => {
                  setAlertModal(false);
                  DoctorActiveDeactive();
                }}
              >
                {t("Ok")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>
      </div>
    </>
  );
}
